<template>
  <section id="contact">
    <div class="bg-tan pv5 w-100">
      <div class="center flex-l justify-center mw9 w-100 w-80-xl">
        <div class="center-m ph3 pl2-l pr6-l w-100 w-50-l w-80-m">
          <h2 class="f2 fw3 ma0 mb3 warm-black">Contact Us Today</h2>
          <p class="f5 lh-double mb4 mb0-l warm-black">Please contact us at <a
            href="tel:1-505-792-1110"
            class="link-inline link-inline--warm-black">(505) 792-1110 ext. 1</a>, or toll free in the US and Canada at <a
              href="tel:1-855-898-6824"
              class="link-inline link-inline--warm-black">(855) 898-6824</a>, use our online inquiry form, or email us at <a
                href="mailto:sales@ideum.com"
                class="link-inline link-inline--warm-black">sales@ideum.com</a>. The Pico is sold domestically and internationally. We also rent the Pico and other multitouch tables and touch walls in the US.
          </p>
        </div>
        <div class="center-m flex flex-column flex-wrap items-center justify-between-m justify-center justify-center-l ph3 w-100 w-80-m w-20-l">
          <a
            href="https://ideum.com/products/touch-tables/pico"
            target="_blank"
            rel="noopener">
            <app-button
              id="about"
              class="mb3 mb3-l">
              About Pico
            </app-button>
          </a>
          <a
            href="https://ideum.com/contact"
            target="_blank"
            rel="noopener">
            <app-button
              id="inquiry"
              class="mt3 mt3-l">
              Inquiry Form
            </app-button>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AppButton from '@/components/AppButton'

export default {
  name: 'SectionContact',

  components: {
    AppButton
  }
}
</script>
